module.exports = __webpack_public_path__ + "img/level_five_hover.71450f57.png";